import { CustomRequestResponse } from './custom-request';

export const parseSuccessResponse = async (
  response: Response,
): Promise<CustomRequestResponse> => {
  const contentType = response.headers.get('Content-Type');

  if (
    (!contentType || !contentType.includes('application/json')) ||
    response.status === 204
  ) {
    return {
      status: response.status,
      message: response.statusText,
      response,
    };
  }

  const json = await response.json();
  return {
    status: response.status,
    message: response.statusText,
    response: json,
  };
};
